import { ViewController, ModelUpdateEvent } from "@gaming/srvg-classes-core";
import { CompetitionTimelineView } from "../../View/CompetitionTimelineView";
import { CHUNK_MODEL_CHUNK } from "../../Model/ChunkModel";


export class CompetitionTimelineViewController extends ViewController {
    competitionTimelineView: CompetitionTimelineView;

    constructor ( options ) {
        options = options || {};
        options.view = options.competitionTimelineView || null;
        super( options );

        this.competitionTimelineView = options.competitionTimelineView;

        app.timeline.currentChunkModel.addSubscriberForEvent( this, ModelUpdateEvent );
    }

    /**
     * If CurrentChunkModel event happens, call highlightChunkNr() to highlight the actual matchday.
     * @param event
     * @param provider
     */
    handleModelUpdateEvent( event: ModelUpdateEvent, provider ) {
        if( provider == app.timeline.currentChunkModel && event.propertyName == CHUNK_MODEL_CHUNK ) {
            this.competitionTimelineView.highlightChunkNr( event.propertyValue.chunk_id() );
        }
    }
}